import { Campaign } from '../types/campaign';

const DEFAULT_SCHEDULING_LEAD_DAYS = 1;
const MIN_SCHEDULING_LEAD_DAYS = 0;
const MAX_SCHEDULING_LEAD_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

const clampSchedulingLeadDays = (floored: number): number => {
  if (floored < MIN_SCHEDULING_LEAD_DAYS) return MIN_SCHEDULING_LEAD_DAYS;
  if (floored > MAX_SCHEDULING_LEAD_DAYS) return MAX_SCHEDULING_LEAD_DAYS;
  return floored;
};

type SchedulingLeadTimeCampaign = Pick<Campaign, 'minimumSchedulingLeadDays'> & {
  id?: Campaign['id'];
};

export const resolveSchedulingLeadDays = (
  campaign?: SchedulingLeadTimeCampaign | null
): number => {
  const value = campaign?.minimumSchedulingLeadDays;
  if (value === null || value === undefined) {
    return DEFAULT_SCHEDULING_LEAD_DAYS;
  }
  if (typeof value !== 'number' || Number.isNaN(value)) {
    console.warn(
      `[schedulingLeadTime] campaign ${campaign?.id ?? 'unknown'} has invalid minimumSchedulingLeadDays (${String(value)}); using default ${DEFAULT_SCHEDULING_LEAD_DAYS}`
    );
    return DEFAULT_SCHEDULING_LEAD_DAYS;
  }
  const floored = Math.floor(value);
  const clamped = clampSchedulingLeadDays(floored);
  if (clamped !== floored) {
    console.warn(
      `[schedulingLeadTime] campaign ${campaign?.id ?? 'unknown'} has minimumSchedulingLeadDays ${value} outside [${MIN_SCHEDULING_LEAD_DAYS}, ${MAX_SCHEDULING_LEAD_DAYS}]; using ${clamped}`
    );
  }
  return clamped;
};

/** Earliest visit time for open-hours slot filtering (backend). */
export const getEarliestSchedulableTime = (
  campaign?: SchedulingLeadTimeCampaign | null,
  now: Date = new Date()
): Date => {
  const leadDays = resolveSchedulingLeadDays(campaign);
  if (leadDays === 0) {
    return new Date(now);
  }
  return new Date(now.getTime() + leadDays * MS_PER_DAY);
};
